(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseDeleteController',PurchaseDeleteController);

    PurchaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Purchase'];

    function PurchaseDeleteController($uibModalInstance, entity, Purchase) {
        var vm = this;
        vm.purchase = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Purchase.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
